(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ph-commerce"] && !Shopify.designMode) return;
  try {
    (() => {
  function validQuantity(value, minimum, increment, maximum) {
    return Number.isSafeInteger(value) && value >= 0 && (value === 0 || (value >= minimum && (value - minimum) % increment === 0 && value <= maximum));
  }
  function selectedItems(inputs) {
    return inputs.filter(input => input.dataset.buyable === 'true' && Number(input.value) > 0).map(input => ({id: input.dataset.orderVariant, quantity: Number(input.value)}));
  }
  function createCartTransport(config) {
    async function request(url, options = {}) {
      let response, data;
      try { response = await config.fetcher(url, {...options, credentials: 'same-origin', cache: 'no-store'}); data = await response.json(); } catch { throw new Error(config.error); }
      if (!response.ok || Number(data.status) >= 400) {
        const detail = data.description || data.message || data.errors;
        const message = typeof detail === 'string' ? detail : detail ? Object.values(detail).flat().join(' ') : config.error;
        throw new Error(message || config.error);
      }
      return data;
    }
    async function mutate(url, body) {
      if (body instanceof FormData) {
        body.set('sections', config.sectionIds.join(','));
        body.set('sections_url', config.path);
        return request(url, {method: 'POST', body});
      }
      return request(url, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({...body, sections: config.sectionIds, sections_url: config.path})});
    }
    return {
      add: body => mutate(config.addUrl, body),
      change: (id, quantity) => mutate(config.changeUrl, {id, quantity}),
      load: () => {
        const url = new URL(config.pageUrl);
        url.searchParams.delete('section_id');
        url.searchParams.set('sections', config.sectionIds.join(','));
        return request(url.toString(), {headers: {Accept: 'application/json'}});
      }
    };
  }
  function start() {
    const initialDrawer = document.querySelector('[data-cart-drawer]');
    if (!initialDrawer || typeof initialDrawer.showModal !== 'function' || window.PrintHausCommerce) return;
    const strings = initialDrawer.dataset;
    const cartPage = document.querySelector('[data-cart-page]');
    const sectionIds = [strings.sectionId, ...(cartPage ? [cartPage.dataset.sectionId] : [])];
    const transport = createCartTransport({fetcher: window.fetch.bind(window), addUrl: strings.addUrl, changeUrl: strings.changeUrl, sectionIds, path: window.location.pathname, pageUrl: window.location.href, error: strings.error});
    let busy = false;
    let requiresSync = false;
    let opener = null;
    let restoreControls = [];
    const drawer = () => document.querySelector('[data-cart-drawer]');
    function status(message) { const node = drawer()?.querySelector('[data-cart-status]'); if (node) node.textContent = message || ''; }
    function error(message, form) {
      const node = form?.querySelector('[data-cart-form-error]') || drawer()?.querySelector('[data-cart-error]');
      if (node) { node.textContent = message || ''; node.hidden = !message; }
    }
    function clearErrors(form) { error('', form); error(''); }
    function setBusy(value, form) {
      busy = value;
      const panel = drawer();
      panel?.setAttribute('aria-busy', String(value));
      form?.setAttribute('aria-busy', String(value));
      if (value) {
        const controls = [...(panel?.querySelectorAll('[data-cart-content] button, [data-cart-content] input') || []), ...(form?.querySelectorAll('button, input, select, textarea') || [])];
        restoreControls = controls.map(node => ({node, disabled: node.disabled}));
        controls.forEach(node => { node.disabled = true; });
      } else {
        restoreControls.forEach(({node, disabled}) => { if (node.isConnected) node.disabled = disabled; });
        restoreControls = [];
        if (requiresSync) panel?.querySelectorAll('[data-cart-checkout]').forEach(node => { node.disabled = true; });
        const product = form?.closest('[data-product-section]');
        const selected = product?.querySelector('[data-variant-id][aria-current="true"]');
        const add = form?.querySelector('[data-add]');
        if (add && selected) { add.disabled = selected.dataset.buyable !== 'true'; add.textContent = selected.dataset.button; }
        if (product) updatePacks(product);
        updateAllOrders();
      }
    }
    function open(trigger) {
      const panel = drawer();
      if (!panel) return;
      if (!panel.open) {
        opener = trigger || document.activeElement;
        panel.showModal();
        document.documentElement.classList.add('ph-cart-open');
        panel.querySelector('[data-cart-close]')?.focus();
      }
    }
    function applySections(sections) {
      const html = sections?.[strings.sectionId];
      if (typeof html !== 'string') return false;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const incoming = parsed.querySelector('[data-cart-content]');
      const current = drawer()?.querySelector('[data-cart-content]');
      if (!incoming || !current) return false;
      const page = document.querySelector('[data-cart-page]');
      let nextPage;
      if (page) {
        const pageHTML = sections[page.dataset.sectionId];
        if (typeof pageHTML !== 'string') return false;
        nextPage = new DOMParser().parseFromString(pageHTML, 'text/html').querySelector('[data-cart-page]');
        if (!nextPage) return false;
        const note = page.querySelector('[name=note]');
        if (note && nextPage.querySelector('[name=note]')) nextPage.querySelector('[name=note]').value = note.value;
      }
      if (page) page.replaceWith(nextPage);
      current.innerHTML = incoming.innerHTML;
      current.dataset.itemCount = incoming.dataset.itemCount;
      document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = incoming.dataset.itemCount; });
      requiresSync = false;
      document.dispatchEvent(new CustomEvent('printhaus:cart-updated', {detail: {itemCount: Number(incoming.dataset.itemCount)}}));
      return true;
    }
    async function synchronise(data) {
      if (applySections(data?.sections)) return;
      if (!applySections(await transport.load())) throw new Error(strings.syncError);
    }
    function updateOrder(form) {
      const root = form.closest('[data-bulk-order-root]');
      const inputs = [...form.querySelectorAll('[data-order-quantity]')];
      let quantity = 0, subtotal = 0, valid = true;
      inputs.forEach(input => {
        const count = Number(input.value);
        const allowed = input.dataset.buyable === 'true';
        const correct = validQuantity(count, Number(input.dataset.min), Number(input.dataset.step), input.max === '' ? Infinity : Number(input.max));
        input.setCustomValidity(allowed && !correct ? root.dataset.ruleError : '');
        if (allowed && !correct) valid = false;
        if (allowed && correct) { quantity += count; subtotal += count * Number(input.dataset.price); }
        input.closest('[data-order-row]').dataset.selected = String(allowed && correct && count > 0);
      });
      form.querySelector('[data-order-count]').textContent = String(quantity);
      try { form.querySelector('[data-order-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: root.dataset.currency || 'GBP'}).format(subtotal / 100); } catch { form.querySelector('[data-order-total]').textContent = (subtotal / 100).toFixed(2); }
      form.querySelector('[data-order-add]').disabled = busy || !valid || quantity === 0;
      return {inputs, valid, quantity};
    }
    function updateAllOrders() { document.querySelectorAll('[data-bulk-order-form]').forEach(updateOrder); }
    function initForms() {
      document.querySelectorAll('[data-cart-open]').forEach(link => { link.setAttribute('aria-haspopup', 'dialog'); link.setAttribute('aria-controls', 'PrintHausCartDrawer'); });
      document.querySelectorAll('[data-bulk-order-form]').forEach(form => { form.hidden = false; form.closest('[data-bulk-order-root]').querySelector('[data-order-fallback]')?.setAttribute('hidden', ''); updateOrder(form); });
      document.querySelectorAll('[data-pack-options]').forEach(node => { node.hidden = false; });
      document.querySelectorAll('[data-product-section]').forEach(updatePacks);
      if (!drawer()?.open) document.documentElement.classList.remove('ph-cart-open');
    }
    function updatePacks(root) {
      const quantity = root.querySelector('[data-quantity]');
      const variant = root.querySelector('[data-variant-id][aria-current="true"]');
      if (!quantity || !variant) return;
      root.querySelectorAll('[data-pack-quantity]').forEach(button => {
        const count = Number(button.dataset.packQuantity);
        button.disabled = variant.dataset.buyable !== 'true' || !validQuantity(count, Number(quantity.min), Number(quantity.step), quantity.max === '' ? Infinity : Number(quantity.max));
        button.setAttribute('aria-pressed', String(Number(quantity.value) === count));
      });
    }
    async function add(form, payload, trigger) {
      if (busy) { error(strings.busy, form); return; }
      clearErrors(form);
      setBusy(true, form);
      let added = false;
      try {
        const data = await transport.add(payload);
        added = true;
        await synchronise(data);
        form.querySelectorAll('[data-order-quantity]').forEach(input => { input.value = '0'; });
        open(trigger);
        status(strings.added);
      } catch (failure) {
        let synced = false;
        try { await synchronise(); synced = true; } catch { requiresSync = true; }
        form.querySelectorAll('[data-order-quantity]').forEach(input => { input.value = '0'; });
        const message = added ? strings.syncError : (failure.message || strings.error) + ' ' + strings.syncError;
        error(message, form);
        open(trigger);
        error(message);
        status('');
        if (!synced) requiresSync = true;
        drawer()?.querySelector('[data-cart-error]')?.focus();
      } finally { setBusy(false, form); }
    }
    async function change(line, quantity, control) {
      if (busy) return;
      const key = line.dataset.key;
      const index = [...drawer().querySelectorAll('[data-cart-line]')].indexOf(line);
      clearErrors(); setBusy(true); status(strings.loading);
      try {
        await synchronise(await transport.change(key, quantity));
        status(strings.updated);
        const lines = [...drawer().querySelectorAll('[data-cart-line]')];
        const target = lines.find(node => node.dataset.key === key) || lines[Math.min(index, lines.length - 1)];
        (target?.querySelector('[data-control="' + control + '"]') || drawer().querySelector('[data-cart-close]'))?.focus();
      } catch (failure) {
        try { await synchronise(); } catch { requiresSync = true; }
        status(''); error(failure.message || strings.error);
        drawer()?.querySelector('[data-cart-error]')?.focus();
      } finally { setBusy(false); }
    }
    async function refreshCart(trigger) {
      open(trigger);
      if (busy) return;
      clearErrors(); setBusy(true); status(strings.loading);
      try { await synchronise(); status(''); } catch { requiresSync = true; status(''); error(strings.syncError); } finally { setBusy(false); }
    }
    document.addEventListener('click', event => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      const cartLink = target.closest('[data-cart-open]');
      if (cartLink && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) { event.preventDefault(); refreshCart(cartLink); return; }
      if (target.closest('[data-cart-close]') || target === drawer()) { drawer()?.close(); return; }
      const pack = target.closest('[data-pack-quantity]');
      if (pack) { if (pack.disabled || busy) return; const root = pack.closest('[data-product-section]'); const input = root.querySelector('[data-quantity]'); input.value = pack.dataset.packQuantity; input.dispatchEvent(new Event('input', {bubbles: true})); updatePacks(root); return; }
      const remove = target.closest('[data-cart-remove]');
      if (remove && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) { event.preventDefault(); change(remove.closest('[data-cart-line]'), 0, 'remove'); return; }
      const adjust = target.closest('[data-cart-adjust]');
      if (adjust) {
        const line = adjust.closest('[data-cart-line]'), input = line.querySelector('[data-cart-quantity]');
        const min = Number(input.dataset.min), step = Number(input.dataset.step), current = Number(input.dataset.original);
        let quantity = current + Number(adjust.dataset.cartAdjust) * step;
        if (quantity < min) quantity = Number(adjust.dataset.cartAdjust) < 0 ? 0 : min;
        if (input.max !== '' && quantity > Number(input.max)) { error(strings.ruleError); return; }
        change(line, quantity, adjust.dataset.control);
      }
    });
    document.addEventListener('submit', event => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if ((form.closest('[data-cart-drawer]') || form.matches('.ph-cart-form')) && (busy || requiresSync)) { event.preventDefault(); open(event.submitter); error(requiresSync ? strings.syncError : strings.busy); return; }
      if (form.matches('[data-bulk-order-form]')) {
        event.preventDefault();
        if (busy) return;
        const state = updateOrder(form);
        if (!state.valid || !form.reportValidity()) return;
        if (!state.quantity) { error(form.closest('[data-bulk-order-root]').dataset.emptyError, form); return; }
        add(form, {items: selectedItems(state.inputs)}, event.submitter);
      } else if (form.matches('.ph-product-form')) {
        event.preventDefault();
        if (busy || form.querySelector('[data-add]')?.disabled || !form.reportValidity()) return;
        add(form, new FormData(form), event.submitter);
      }
    });
    document.addEventListener('input', event => {
      const input = event.target;
      if (input.matches?.('[data-order-quantity]')) { error('', input.form); updateOrder(input.form); }
      if (input.matches?.('[data-quantity]')) updatePacks(input.closest('[data-product-section]'));
    });
    document.addEventListener('change', event => {
      const input = event.target;
      if (!input.matches?.('[data-cart-quantity]')) return;
      const quantity = Number(input.value);
      if (!validQuantity(quantity, Number(input.dataset.min), Number(input.dataset.step), input.max === '' ? Infinity : Number(input.max))) { input.value = input.dataset.original; error(strings.ruleError); return; }
      if (quantity !== Number(input.dataset.original)) change(input.closest('[data-cart-line]'), quantity, 'quantity');
    });
    document.addEventListener('keydown', event => { if (event.key === 'Enter' && event.target.matches?.('[data-cart-quantity]')) { event.preventDefault(); event.target.blur(); } });
    document.addEventListener('close', event => {
      if (!event.target.matches?.('[data-cart-drawer]')) return;
      document.documentElement.classList.remove('ph-cart-open');
      const target = opener?.isConnected && !opener.disabled ? opener : document.querySelector('[data-cart-open]');
      target?.focus();
    }, true);
    document.addEventListener('printhaus:variant-changed', event => updatePacks(event.target));
    document.addEventListener('shopify:section:load', initForms);
    window.PrintHausCommerce = {refreshCart};
    initForms();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
